import React, { Component } from 'react';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import Sidebar from '../../Components/Sidebar';
import Btn from '../../Components/Btn';
import Checkbox from '../../Components/Checkbox';
import { userPermissions } from '../../config';
import { bindActionCreators } from 'redux';
import { createAdmin } from '../../store/user/actions';
import Alert from '../../Components/Alert';
import { generateID } from '../../helpers/generators';

class NewAdmin extends Component {
  state = {
    name: '',
    email: '',
    pass: '',
    permissions: []
  }

  handleDoubleClick = (e) => {
    let newPass = generateID(8);
    this.setState({[e.target.name]: newPass});
  }

  handleFieldChange = (e) => {
    this.setState({[e.target.name]: e.target.value});
  }

  handlePermissionChange = (e) => {
    const currentPermissions = Object.assign([], this.state.permissions);
    if (e.target.checked) {
      // add permission
      currentPermissions.push(e.target.name);
    } else {
      // remove permission
      currentPermissions.splice(currentPermissions.indexOf(e.target.name), 1);
    }

    this.setState({permissions: currentPermissions});
  }

  addAdmin = (e) => {
    e.preventDefault();

    this.props.addAdmin({ 
      name: this.state.name,
      email: this.state.email,
      password: this.state.pass,
      permissions: this.state.permissions
     }, () => {
       this.props.history.replace('/admins', { adminCreated: true, email: this.state.email })
     });
  }

  render() {
    return (
      <div className="wrapper">
        <Sidebar/>
        <div className="main-panel">
          <div className="page-title">
            <div className="page-title-heading">
              <h1>Add New Admin</h1>
            </div>
          </div>
          <hr/>
          <Alert color="red" msg={this.props.user.error} />
          <form className="addAdminForm" onSubmit={this.addAdmin}>
            <div className="form-field">
              <h5 className="label">Full Name</h5>
              <input type="text" name="name" onChange={this.handleFieldChange} required value={this.state.name} />
            </div>
            <div className="form-field">
              <h5 className="label">Email Address</h5>
              <input type="email" name="email" onChange={this.handleFieldChange} required value={this.state.email} />
            </div>
            <div className="form-field">
              <h5 className="label">Temporary Password</h5>
              <input type="text" name="pass" onDoubleClick={this.handleDoubleClick} onChange={this.handleFieldChange} required value={this.state.pass} />
            </div>
            <div className="form-field">
              <h5 className="label">Roles</h5>
              <Checkbox name={userPermissions.viewBookings} text={'View Bookings'} onChange={this.handlePermissionChange} />
              <Checkbox name={userPermissions.viewCustomers} text={'View Customers'} onChange={this.handlePermissionChange} />
              <Checkbox name={userPermissions.viewSettings} text={'View Settings'} onChange={this.handlePermissionChange} />
            </div>
            <hr/>
            <Btn className="btn submit">add admin</Btn>
          </form>
          
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user
})

const mapDispatchToProps = dispatch => ({
  addAdmin: bindActionCreators(createAdmin, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NewAdmin));